import { render, staticRenderFns } from "./CustomerMarketingCampaignAggregatedActivity.vue?vue&type=template&id=3498a0e8&"
import script from "./CustomerMarketingCampaignAggregatedActivity.vue?vue&type=script&lang=js&"
export * from "./CustomerMarketingCampaignAggregatedActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports